import { combineReducers } from "redux";
import user from "./user/reducer";
import dealer from "./dealer/reducer";
import country from "./country/reducer";
import auth from "./auth/reducer";
import manualAddFund from "./manualAddFund/reducer";
import addToFund from "./addToFund/reducer";
import plan from "./plan/reducer";
import aggregator from "./aggregator/reducer";
import addonService from "./addonService/reducer";
import network from "./network/reducer";
import activationRequest from "./activationRequest/reducer";
import profile from "./profile/reducer";
import auditReport from "./auditReport/reducer";
import planWiseMapping from "./planWiseMapping/reducer";
import asset from "./asset/reducer";
import addonWiseMapping from "./addonWiseMapping/reducer";
import tmoDealer from "./tMobileDealer/reducer";
import activity from "./activity/reducer";
import dashboard from "./dashboard/reducer";
import activationReport from "./activationReport/reducer";
import assetPerformanceReport from "./assetPerformanceReport/reducer";
import jarUpload from "./jar/reducer";
import manualActivationReport from "./manualActivationReport/reducer";
import bulkActivationReport from "./bulkActivationReport/reducer";
import simSwapRequest from "./simSwapRequest/reducer";
import rechargeRequest from "./rechargeRequest/reducer";
import rechargePlan from "./rechargePlan/reducer";
import shortCode from "./shortCodeData/reducer";
import emailInbox from "./emailInbox/reducer";
import iqRequestReport from "./iqRequestReport/reducer";
import dailyPlanRequest from "./dailyPlanRequest/reducer";
import portinActivation from "./portinActivation/reducer";
import portinInventory from "./PortinInventory/reducer";
import dailyAddonWiseMapping from "./DailyAddonWiseMapping/reducer";
import lockedActivation from "./lockedActivation/reducer";
import apiKey from "./apiKey/reducer";
import outsideEmailInbox from "./outsideEmailInbox/reducer";
import msisdnPool from "./msisdnPool/reducer";
import repushActivation from "./repushActivation/reducer";
import activationStatus from "./activationStatus/reducer";
import mdnSwap from "./MDNSwap/reducer";
import chatrActivation from "./chatrActivation/reducer";
import simPinInventory from "../redux/SIMPINInventory/reducer";
import chatrActivationReport from "../redux/ChatrActivationReport/reducer";
import mdnSwapReport from "../redux/MDNSwapReport/reducer";
import chatrRechargePlan from "../redux/chatrRechargePlan/reducer";
import rechargePriceMapping from "../redux/rechargePriceMapping/reducer"
import chatrRecharge from "../redux/Chatr Recharge Request/reducer"
const rootReducer = combineReducers({
  user,
  country,
  manualAddFund,
  addToFund,
  plan,
  addonService,
  dealer,
  auth,
  network,
  activationRequest,
  activationStatus,
  aggregator,
  profile,
  auditReport,
  planWiseMapping,
  asset,
  addonWiseMapping,
  tmoDealer,
  activity,
  dashboard,
  activationReport,
  assetPerformanceReport,
  jarUpload,
  manualActivationReport,
  bulkActivationReport,
  simSwapRequest,
  rechargeRequest,
  rechargePlan,
  shortCode,
  emailInbox,
  iqRequestReport,
  dailyPlanRequest,
  portinActivation,
  portinInventory,
  dailyAddonWiseMapping,
  lockedActivation,
  apiKey,
  outsideEmailInbox,
  msisdnPool,
  repushActivation,
  mdnSwap,
  chatrActivation,
  simPinInventory,
  chatrActivationReport,
  mdnSwapReport,
  chatrRechargePlan,
  rechargePriceMapping,
  chatrRecharge,
});
export default rootReducer;
